<app-layout>
  <div class="terms-of-use">
    <div class="terms-of-use__section">
      <div class="terms-of-use__header">
        <div class="terms-of-use__title">
          <p class="h1 text-white">Termos e condições de uso</p>
        </div>
        <div class="terms-of-use__subtitle">
          <p>Informe-se sobre os termos e condições de uso de nossa plataforma</p>
        </div>
      </div>
    </div>

    <div class="terms-of-use__text">
      <div class="container">
        <h3>1. GLOSSÁRIO</h3>
        <p>Para os fins dos Termos de Condições de Uso em apreço, são aplicáveis as seguintes definições:</p>

        <p>
          Plataforma da Yes7 Tickets: plataforma disponibilizada para promover a intermediação entre os organizadores e
          os participantes, realizando a organizando e venda de ingressos de eventos.
        </p>
        <br />
        <p>
          Organizador: pessoa física ou jurídica que promove os eventos por intermédio da Plataforma da Yes7 Tickets.
        </p>
        <br />
        <p>Usuários: consumidores que navegam na Plataforma da Yes7 Tickets.</p>
        <br />
        <p>
          Participante: consumidor que adquire ingressos dos eventos criados pelo Organizador por intermédio da
          Plataforma Yes7 Tickets.
        </p>
        <br />
        <p>
          Interface de Programação de Aplicação — API: um intermediário de serviços e plataformas que permite que dois
          aplicativos conversem entre si.
        </p>
        <br />
        <p>
          Iugu: Instituição de Pagamento S/A é uma instituição autorizada pelo Banco Central, plataforma de pagamento
          online para negócios digitais.
        </p>
        <br />
        <p>Dashboard: painel de informações, indicadores e métricas importantes para o funcionamento de uma empresa.</p>
        <br />
        <p>
          Consumidores: toda pessoa física ou jurídica que adquire ou utiliza produto ou serviço como destinatário
          final.
        </p>
        <br />
        <p>
          Estornos: devolução dos valores recebidos pelos Organizadores, em razão do cancelamento do evento ou de
          solicitação do consumidor que adquiriu os ingressos.
        </p>
        <br />
        <p>
          Serviços: conjunto de produtos e serviços disponibilizados pela Yes7 Tickets, nos termos deste regulamento.
        </p>
        <br />
        <p>Autenticação: processo de segurança que atesta a veracidade.</p>
        <br />
        <p>
          QR Code — “Quick Response Code”: Código de resposta rápida. Compilado de informações em uma imagem quadrada em
          preto e branco.
        </p>
        <br />
        <p>
          Credenciais de acesso: As credenciais de acesso são nomes de usuário e senhas gerenciados que dão acesso a
          plataforma da Yes7 Tickets.
        </p>
        <br />

        <h3>2. INSTRUÇÕES SOBRE OS TERMOS DE CONDIÇÕES DE USO</h3>

        <p>
          O Termo de Condições de Uso em apreço se refere a plataforma digital YES 7 TICKETS LTDA., pessoa jurídica de
          direito privado, inscrita no CNPJ/MF nº 54.728.376/0001-46, com sede na Foz do Iguaçu - PR.
        </p>
        <p>
          Ressalta-se que, a utilização da plataforma pelo usuário está condicionado ao aceite dos termos e políticas
          associadas, portanto, é essencial a leitura dos documentos, certificando-se do entendimento. Ao concordar com
          as condições previstas nos Termos de Condições de Uso o usuário compromete-se a cumpri-las.
        </p>
        <p>
          Ante a utilização do serviço, o usuário manifesta a livre e inequívoca concordância com o presente Termos de
          Uso, estando, portanto, legalmente vinculado aos termos expostos.
        </p>

        <h3>3. SERVIÇOS DA PLATAFORMA Yes7 Tickets</h3>

        <p>3.1 Descrição da finalidade</p>

        <p>
          A Yes7 Tickets promove a intermediação da organização de eventos e venda dos respectivos ingressos, pagos ou
          gratuitos, viabilizando a criação e gerenciamento dos eventos de modo simplificado e desburocratizado pelos
          Organizadores. Destaca-se que a Yes7 Tickets não promove eventos, mas tão somente realiza a conexão entre
          organizador e participante.
        </p>

        <p>
          Tem-se como finalidade a intermediação entre os organizadores e participantes, beneficiando ambas as partes
          com uma plataforma inovadora e intuitiva. Proporcionando, portanto, uma experiência rápida para a aquisição de
          ingressos pelos participantes e para os organizadores, transformando o tempo despendido com o gerenciamento de
          ingressos em produtividade.
        </p>

        <p>
          Nos termos do presente regulamento, a Yes7 Tickets prestará serviços de intermediação em planejamento de
          eventos e as vendas dos ingressos, não sendo, portanto, a organizadora, tampouco a responsável pelos eventos.
        </p>

        <p>
          Os serviços e produtos da Yes7 Tickets serão disponibilizados mediante o cadastramento na plataforma, a seguir
          discriminados.
        </p>

        <p>3.2 Organização de eventos</p>

        <p>3.2.1 Criação dos eventos</p>

        <p>
          Para a criação do primeiro evento, o organizador precisa concluir as etapas a seguir discriminadas, pelo
          acesso ao link:
          <a href="https://yes7tickets.com/criar-evento" target="_blank">https://yes7tickets.com/criar-evento</a>
        </p>

        <p>
          1ª Etapa — Detalhes do evento: O organizador deve preencher o formulário com informações básicas, como o nome,
          data e a categoria do evento que planeja criar.
        </p>
        <p>
          2ª Etapa — Localização: Defina a localização do evento ou selecione a plataforma online no qual será
          transmitido.
        </p>
        <p>
          3ª Etapa — Ingressos: Crie quantas espécies de ingressos forem necessárias para efetivação do evento,
          selecionando as taxas mais confortáveis para trabalhar.
        </p>
        <p>
          4ª Etapa — Dados do organizador: O Organizador deve se identificar para facilitar a comunicação com os
          participantes do evento.
        </p>
        <p>
          5ª Etapa — Publicação: Ao publicar o evento, o Organizador pode começar a divulgá-lo, iniciando as vendas de
          forma fácil e descomplicada.
        </p>

        <p>
          A plataforma da Yes7 Tickets disponibiliza o evento criado pelo Organizador após o término dos procedimentos
          indicados, com uma página exclusiva e pronta para o início das vendas.
        </p>

        <p>3.2.2 Preços da Yes7 Tickets</p>

        <p>A Plataforma Yes7 Tickets oferece acesso gratuito aos serviços de criação e gerenciamento de eventos.</p>
        <p>
          Para o Organizador promover eventos pagos, a Yes7 Tickets cobra uma taxa mínima de 7,9% (sete vírgula nove por
          cento) referente ao serviço, calculadas sob o valor das inscrições concretizadas e recebidas com pagamento à
          vista — referida taxa pode variar a depender do evento. Sendo o percentual cobrado sobre o valor dos ingressos
          inferior a R$ 2,50 (dois reais e cinquenta centavos), a Yes7 Tickets cobrará a taxa mínima de R$ 2,50 (dois
          reais e cinquenta centavos).
        </p>
        <p>
          Em pagamentos parcelados — possíveis em até 12x (doze vezes), a depender do Organizador — incidirá uma taxa de
          juros proporcional à quantidade de parcelas. Referidos valores serão pagos por intermédio da Iugu — plataforma
          de pagamento online — que irá repassar o valor do ingresso ao Organizador, transferindo, simultaneamente, a
          taxa cobrada pela Yes7 Tickets, sem burocracia e de modo simples.
        </p>
        <p>O processamento de pagamentos pela plataforma Iugu pode ser realizado nas seguintes modalidades:</p>
        <p>Boleto bancário;</p>
        <p>Cartão de crédito;</p>
        <p>Pix;</p>
        <p>
          É responsabilidade do Organizador cadastrar os dados bancários corretos e atualizados para o repasse dos
          valores da venda de ingressos.
        </p>
        <p>
          Ocorrendo problemas com o pagamento do usuário, a Yes7 Tickets analisará a melhor solução com a Iugu, por esta
          razão é importante que o usuário acione imediatamente a plataforma pelo endereço eletrônico: contato&#64;Yes7
          Tickets.com.br.
        </p>
        <p>3.2.3 Venda de ingressos e repasse dos valores ao Organizador do evento</p>
        <p>
          Na medida que os participantes comprarem os ingressos, a quantia relativa ao preço será inclusa no dashboard
          do Organizador — painel de informações — facilitando a visualização do montante integral arrecadado.
        </p>
        <p>
          Os valores referentes aos ingressos vendidos, serão repassados ao Organizador em até 3 (três) dias úteis após
          o término do evento.
        </p>
        <p>
          A Yes7 Tickets esclarece que o prazo, para o repasse do montante arrecadado com os ingressos, considera a data
          que o evento efetivamente ocorrerá, independe da data cadastrada pelo Organizador na plataforma. Se a data do
          evento e a data cadastrada na plataforma não coincidirem, o repasse dos valores poderá ser postergado para o
          terceiro dia útil após a data em que o evento for finalizado.
        </p>
        <p>
          O repasse é realizado automaticamente à conta bancária cadastrada pelo Organizador, contendo as vendas, em sua
          integralidade, realizadas via Pix, boleto bancário e cartão de crédito.
        </p>
        <p>
          Os saques efetuados, especialmente no tocante à cobrança de taxas, estão sujeitos aos Termos de Condições de
          Uso da Iugu, disponível em: https://www.iugu.com/juridico/contrato
        </p>
        <p>
          A Yes7 Tickets informa a existência de prazo adicional para a realização de transferência da Iugu ao
          Organizador, podendo ser de 1 (um) dia ou mais, a depender da instituição financeira selecionada pelo
          Organizador.
        </p>
        <p>
          Destaca-se que a Yes7 Tickets não se responsabiliza por eventuais atrasos no pagamento por falha da Iugu, ou
          das operadoras de cartão de crédito e instituições financeiras.
        </p>
        <p>
          Ocorrendo problemas no pagamento, a Yes7 Tickets se compromete em colaborar com o Organizador para solucionar
          a demanda. Na constatação de fraude, a Yes7 Tickets poderá, sem avisar previamente, suspender a transação a
          fim de analisar internamente a operação, podendo, inclusive, compartilhar os dados inerentes ao pagamento com
          as autoridades policiais.
        </p>
        <p>
          A Yes7 Tickets poderá solicitar documentos complementares para autenticação do Comprador, com o intuito de
          analisar a veracidade do pagamento, sendo realizado através do número de Whatsapp oficial terminado em 67587,
          ou pelo e-mail contato&#64;Yes7 Tickets.com.br.
        </p>
        <p>3.2.4 Emissão de nota fiscal</p>
        <p>
          Com término dos eventos em que incidir a taxa de serviço cobrada, a Yes7 Tickets emitirá uma nota fiscal
          referente ao montante de taxas cobradas neste evento em nome do organizador (tomador do serviço). Os dados
          para a emissão desta nota fiscal serão os utilizados no cadastramento da conta bancária na criação do evento.
        </p>
        <p>
          O Organizador é o único e exclusivo responsável pelo pagamento dos tributos referentes ao valor total
          arrecadado com as vendas dos ingressos do respectivo evento, estando a Yes7 Tickets isenta de
          responsabilidades no tocante a este(s) pagamento(s).
        </p>
        <p>3.2.5 Restituição de valores aos consumidores</p>
        <p>
          É de responsabilidade integral do Organizador do evento manter políticas claras no tocante ao cancelamento e
          restituição de valores aos consumidores. A Yes7 Tickets informa que não se responsabilizará por eventuais
          prejuízos decorrentes do cancelamento de eventos.
        </p>
        <p>
          Eventual restituição de valores aos participantes deve ser realizada pelo Organizador pelo valor exato da
          transação.
        </p>
        <p>
          O Organizador de eventos compromete-se a respeitar as regras de proteção ao consumidor, declarando sua
          integral responsabilidade por eventual violação, reconhecendo que a Yes7 Tickets não é responsável por
          quaisquer valores ou serviços relacionados às obrigações consumeristas.
        </p>
        <p>
          A restituição dos valores aos participantes devem ser realizados às expensas e sob exclusiva responsabilidade
          do Organizador, não podendo responsabilizar ou realizar cobranças por ação de regresso contra a Yes7 Tickets.
        </p>
        <p>
          Sendo a Yes7 Tickets demandada para efetuar a restituição dos valores aos participantes, o Organizador será
          imediatamente notificado para proceder à restituição, às suas exclusivas expensas e sob pena de
          responsabilidade. Ante a inércia do Organizador, estando os valores dos ingressos na plataforma, a Yes7
          Tickets se reserva o direito de deduzir dos valores arrecadados com os ingressos o montante necessário para
          realizar o reembolso ao consumidor.
        </p>
        <p>
          Com a manutenção da conduta do Organização em não restituir os participantes, em prazo hábil e nas condições
          legais, e não sendo possível pela Yes7 Tickets realizar deduções dos valores arrecadados com os ingressos, a
          Yes7 Tickets ajuizará processo a fim de proceder à cobrança dos valores devidos. Podendo, inclusive, adotar as
          medidas judiciais cabíveis e inscrever o nome do Organizador nos órgãos de proteção de crédito.
        </p>
        <p>3.2.6 Funcionamento dos Eventos</p>
        <p>
          Os eventos criados se manterão ativos pelo período designado pelo próprio organizador. Contudo, a Yes7 Tickets
          se resguarda no direito de manter todos os eventos criados em seu banco de dados pelo prazo de 5 (cinco) anos,
          a partir de seu encerramento, tendo em vista a possibilidade do participante poder acionar a Yes7 Tickets
          judicialmente em razão de não satisfação com o evento.
        </p>
        <p>
          Em que pese a divulgação do evento dependa integralmente do Organizador, a Yes7 Tickets implementou
          funcionalidade na plataforma, para que o organizador e o participante compartilhem os eventos em redes sociais
          como Facebook, LinkedIn e Twitter, por meio de interface própria, para viabilizar a promoção do evento.
        </p>
        <p>
          Os eventos poderão ser divulgados e indicados em mecanismos de buscas e anúncios, possuindo acesso público e
          irrestrito de terceiros, bem como poderão ser mantidos em privado. No entanto, é vedado ao organizador inserir
          informações confidenciais ou de terceiros nos eventos.
        </p>
        <p>
          É disponibilizado ao Organizador, ferramenta para gerar dados estatísticos do evento organizado, respeitando a
          devida anonimização, conforme a Política de Privacidade e Cookies.
        </p>
        <p>
          Em eventual necessidade de cancelamento, pelo Organizador, de evento o qual já teve a venda parcial dos
          ingressos, o Organizador deverá entrar em contato com equipe da Yes7 Tickets, assumindo a integral
          responsabilidade frente os reembolsos de cada comprador por meio do painel do evento.
        </p>
        <p>
          A Yes7 Tickets se reserva ao direito de alertar, suspender ou cancelar todo e qualquer evento manifestamente
          ilegal, ilícito ou que infrinja seus Termos de Condições de Uso e suas outras políticas.
        </p>
        <p>
          A Yes7 Tickets não se responsabiliza por custos complementares arcados pelos organizadores para verificação da
          autenticidade do ingresso. Sob nenhuma circunstância, a Yes7 Tickets se responsabilizará por custos ou danos
          associados a ingressos decorrentes de situações de fraude, ou por danos associados com a aquisição de ingresso
          por outros meios não oficiais.
        </p>
        <p>3.3 Do ingresso e dos direitos dos compradores</p>
        <p>
          Ao adquirir o ingresso, o usuário deve informar os dados cadastrais e o CPF, para confirmação da titularidade
          de pagamento. No dashboard estará disponível a compra do ingresso e o respectivo evento. Cada ingresso possui
          um código de identificação próprio e um QR Code, que pode ser utilizado para o Organizador permitir a entrada
          no evento.
        </p>
        <p>
          Após os participantes efetuarem a aquisição do ingresso por meio da Plataforma Yes7 Tickets, há três maneiras
          de acessá-los:
        </p>
        <p>
          E-mail recebido após a confirmação de compra — Neste e-mail constará o acompanhamento do processo de compra
          dos ingressos, e também outra mensagem contendo os ingressos, enviada logo após a confirmação do pagamento.
        </p>
        <p>
          Site da Yes7 Tickets —
          <a href="https://yes7tickets.com" target="_blank">https://yes7tickets.com</a>
          — acesse com suas credenciais e clique no menu superior em “Meus Ingressos”.
        </p>
        <p>
          Aplicativo da Yes7 Tickets — disponível para Android e IOS. Neste caso, o usuário precisará fazer login ou
          criar uma conta com o mesmo e-mail utilizado no momento da compra.
        </p>
        <p>
          O ingresso adquirido poderá ser impresso ou apresentado virtualmente na data do evento, oportunidade na qual o
          Organizador validará sua autenticidade. É responsabilidade do Organizador informar a forma de validação do
          ingresso, por essa razão a Yes7 Tickets não responde na hipótese de o participante esquecer o ingresso ou não
          o apresentar conforme as exigências do evento, nos termos informados pelo Organizador.
        </p>
        <p>
          A Yes7 Tickets igualmente não se responsabiliza pela situação do Organizador não informar previamente
          eventuais particularidades ou especificidades do evento, sendo a plataforma apenas o intermediário entre a
          compra e venda dos ingressos.
        </p>
        <p>
          Eventual mudança de titularidade do ingresso poderá ser feita pelo aplicativo Yes7 Tickets ou através do site
          <a href="https://yes7tickets.com" target="_blank">https://yes7tickets.com</a>
          desde que seja previamente autorizado pelo organizador do evento em questão.
        </p>
        <p>
          Com a efetivação da transferência do ingresso, o participante compromete-se a descartar o ingresso
          inicialmente gerado, não usando cópia dele para participar do evento, sob pena de responsabilização. A
          violação do disposto constitui fraude, podendo o participante ser responsabilizado civil e criminalmente por
          sua conduta.
        </p>
        <p>
          Em situação de eventual necessidade de cancelamento da compra do ingresso, o requerimento poderá ser realizado
          pelo usuário ao acessar seu pedido através do dashboard da Yes7 Tickets.
        </p>
        <p>
          Ante o cancelamento do ingresso, o participante obriga-se a descartar o ingresso inicialmente gerado, não se
          utilizando de cópia para participar do evento. Assim como na transferência, a violação do disposto constitui
          fraude, podendo o participante ser responsabilizado civil e criminalmente por sua conduta.
        </p>
        <p>
          Em eventual inércia do Organizador quanto a um reembolso obrigatório, a Yes7 Tickets, mediante uma análise da
          justificativa de cancelamento, poderá realizar o reembolso caso o valor ainda não tenha sido repassado, sem
          informar previamente o Organizador.
        </p>
        <p>
          Será estabelecida entre o organizador e o participante a política de reembolso, vez que a Yes7 Tickets
          colabora como mera intermediadora. Deve-se considerar, ainda, a obrigatoriedade no reembolso para solicitações
          apresentadas em até 7 (sete) dias após a data da compra, desde que a solicitação ocorra antes das 48 (quarenta
          e oito) horas que antecedem o início do evento.
        </p>
        <p>
          No tocante à retenção de taxas de administração bancárias (cartões de crédito e boletos, mas não se limitando
          a estes), o Organizador assumirá o dever de reembolsar todo e qualquer valor decorrente da compra do ingresso
          não usufruído após o término do evento, isentando a Yes7 Tickets de qualquer responsabilidade acerca da
          questão.
        </p>
        <p>
          As contestações e solicitações de estorno ocorridos mediante vendas realizadas junto à Yes7 Tickets, são de
          responsabilidade somente do Organizador, independentemente de sua razão. A Yes7 Tickets se colocará como
          responsável por tomar as devidas medidas necessárias para ser aberta uma demanda, caso seja de vontade do
          Organizador. Caberá ao Organizador apresentar os documentos necessários para comprovar o uso dos ingressos por
          parte do participante, segundo os termos de uso e demais disposições da solução de pagamentos Iugu.
        </p>

        <h3>4. CADASTRO DE DADOS PESSOAIS</h3>

        <p>
          Os dados fornecidos pelos usuários serão tratados consoante a Política de Privacidade e Cookies da Yes7
          Tickets.
        </p>
        <p>
          Para utilização dos serviços, é necessário realizar cadastro no site da Yes7 Tickets, no qual deverá ser
          fornecido o nome completo, e-mail para concretização do login e a criação de uma senha pelo usuário. Por
          intermédio da Interface de Programação de Aplicação — API, do Facebook e Google, a conta poderá ser igualmente
          acessada. Para proceder ao cadastro ou realizar a compra de ingressos é necessário conceder autorização à Yes7
          Tickets para a regular coleta dos dados pessoais.
        </p>
        <p>
          Os dados coletados durante o cadastro ou para viabilizar a aquisição dos ingressos são as informações
          estritamente necessárias para viabilizar o ato, quais sejam: nome completo, número do cadastro de pessoas
          físicas — CPF, e-mail, senha, fotografia pessoal de identificação, endereço e número do registro geral — RG.
        </p>
        <p>
          Especialmente para os Organizadores de eventos, será necessário o fornecimento de conta bancária de sua
          titularidade, a qual será utilizada posteriormente para o repasse do montante arrecadado com as vendas dos
          ingressos.
        </p>
        <p>
          O contrário ocorre com os participantes em virtude de o pagamento ser efetuado por intermédio da plataforma
          Iugu, portanto, a Yes7 Tickets não armazena os dados financeiros dos titulares, recebendo em momento posterior
          a confirmação de pagamento, não realizando a coleta ou tratamento das informações dos cartões de crédito.
        </p>
        <p>
          É responsabilidade dos usuários manterem os respectivos dados cadastrais atualizados na Plataforma da Yes7
          Tickets. Havendo necessidade, a Yes7 Tickets poderá solicitar informações ou documentos complementares aos
          usuários.
        </p>
        <p>
          Os usuários autorizam expressamente a Yes7 Tickets realizar a coleta e tratamento dos dados pessoais inseridos
          no ato de cadastramento na plataforma. Do mesmo modo que declaram o pleno consentimento com o compartilhamento
          das informações para o cumprimento de obrigação legal, execução de contrato, execução regular de direitos,
          atendimento de interesses legítimos, para o exercício regular de direitos em processo judicial, administrativo
          ou arbitral.
        </p>
        <p>
          A Yes7 Tickets somente será compelida a disponibilizar os registros de acesso ou informações pessoais,
          incluindo o IP de acesso em sua plataforma, mediante ordem judicial, requisição de autoridade policial ou
          administrativa competente, não havendo obrigatoriedade pela plataforma em atender requisições particulares.
        </p>
        <p>
          Como condição essencial para promoção de sua atividade, a Yes7 Tickets coletará os dados pessoais dos usuários
          cadastrados, compartilhando com o Organizador do Evento. As informações fornecidas pelos usuários serão
          utilizadas somente para a prestação dos serviços, abstendo-se de utilizá-las para fins diversos dos expostos
          no presente Termos de Condições de Uso ou indicados na Política de Privacidade e Cookies da Yes7 Tickets.
        </p>

        <h3>5. REGRAS DE UTILIZAÇÃO DA PLATAFORMA</h3>

        <p>
          O serviço disponibilizado pela Plataforma Yes7 Tickets será prestado aos usuários durante às 24 (vinte e
          quatro) horas e pelos 7 (sete) dias da semana, estando sujeito, contudo, a eventual indisponibilidade
          temporária, decorrente de manutenção, por força maior ou fatos de terceiro que fogem de sua esfera de
          vigilância e responsabilidade.
        </p>
        <p>
          Em caso de indisponibilidade, a Yes7 Tickets buscará restabelecer o acesso o mais breve possível, procedendo à
          comunicação das informações necessárias aos organizadores acerca dos problemas registrados, tão somente quando
          a instabilidade superar mais de 48 (quarenta e oito) horas ininterruptas.
        </p>
        <p>5.1 Forma de utilização e requisitos mínimos</p>
        <p>
          Os interessados em utilizar a plataforma devem se cadastrar pelo link de acesso:
          <a href="https://yes7tickets.com/register" target="_blank">https://yes7tickets.com/register</a>
        </p>
        <p>
          Para tanto, deve ser fornecido o nome, e-mail para criação do login, e a criação de senha ao final. A conta do
          usuário poderá ser igualmente acessada por intermédio do Interface de Programação de Aplicação — API do
          Facebook e do Google, que utilizarão os dados das redes sociais para a inscrição do usuário.
        </p>
        <p>
          O usuário, na criação da conta ou no ato de adquirir ingressos dos eventos, concorda em utilizar a plataforma
          respeitando as regras previstas nos regulamentos.
        </p>
        <p>
          Para utilizar os serviços da Plataforma Yes7 Tickets, o usuário deve ter 18 (dezoito) anos completos ou ser
          legalmente emancipado. O menor de 18 (dezoito) anos e maior 12 (doze) anos somente poderá operar a plataforma
          com a autorização e supervisão dos genitores ou representantes legais. É vedado ao menor de 12 (doze) anos o
          fornecimento de dados pessoais à Yes7 Tickets, devendo os genitores ou representantes legais, em nome próprio,
          concretizar o cadastro e a compra de ingressos na plataforma.
        </p>
        <p>
          As informações fornecidas pelos usuários devem ser verdadeiras e atuais. O usuário-organizador e o
          usuário-participante comprometem-se e anuem com a obrigação de manter os dados pessoais atualizados na
          plataforma, viabilizando a adequada comunicação, sobre atividades e eventos, gerenciados ou inscritos.
        </p>
        <p>
          É vedado na plataforma a propagação de imagens e/ou textos que façam apologia ou compreendam violência ou
          conteúdo sexual. Pelos mesmos fundamentos, proíbe-se a violação do direito de terceiros, no tocante à imagem e
          à propriedade intelectual.
        </p>
        <p>
          Não é permitido que os usuários realizem atividades ilícitas, enganosas, fraudulentas, não autorizadas ou com
          finalidades ilegais na plataforma Yes7 Tickets.
        </p>
        <p>5.2 Propriedade Intelectual</p>
        <p>
          Os usuários reconhecem os direitos de propriedade intelectual inerentes à plataforma disponibilizada e
          desenvolvida pela Yes7 Tickets para prestação dos serviços, permanecendo como propriedade integral e exclusiva
          da Yes7 Tickets.
        </p>
        <p>
          É concedido pelo usuário, à Plataforma Yes7 Tickets, uma licença não exclusiva, transferível e livre de
          royalties, para utilização de qualquer dado, conteúdo e demais informações disponibilizadas em seu nome ou em
          nome de terceiros. Essa licença permanecerá mesmo que o usuário cesse o uso da plataforma.
        </p>
        <p>
          A plataforma da Yes7 Tickets é de propriedade única e exclusiva dela, exclusivamente e não sublicenciável,
          conforme os termos expostos. A Yes7 Tickets outorga aos usuários uma licença de uso pessoal, revogável e
          somente para utilização dos serviços disponibilizados pela plataforma, sendo vedado outras formas de
          utilização da licença concedida.
        </p>

        <h3>6. DAS RESPONSABILIDADES</h3>

        <p>6.1 Sobre a responsabilidade da Yes7 Tickets, do organizador e do participante</p>
        <p>
          É de responsabilidade integral do Organizador informar previamente os participantes as formas e
          especificidades de validação do ingresso, portanto, a Yes7 Tickets não se responsabiliza por eventual inércia
          do Organizador ou descumprimento das exigências pelo Participante.
        </p>
        <p>
          A Yes7 Tickets não se responsabiliza por o participante esquecer o ingresso ou não o apresentar conforme as
          exigências do evento, nos termos da descrição informada pelo Organizador.
        </p>
        <p>
          Ao ponderar que a Yes7 Tickets não organiza ou controla os eventos criados pelos organizadores por intermédio
          da plataforma, cabe ao participante avaliar as informações e detalhes do evento diretamente com o organizador.
          Por atuar única e exclusivamente na intermediação entre o organizador e o participante, não responde por
          qualquer dano causado pelo organizador, de maneira culposa ou dolosa, dano indireto, incidental, consequente,
          especial ou punitivo, decorrente ou relacionado ao uso da plataforma.
        </p>
        <p>
          Não é responsabilidade da Yes7 Tickets as eventuais contestações e/ou solicitações de estornos realizadas
          pelos participantes, declarando o Organizador, ao consentir com os termos da plataforma, sua integral
          responsabilidade.
        </p>
        <p>
          Os Organizadores devem manter políticas claras a respeito de cancelamentos e restituições de valores, vez que
          a Yes7 Tickets não se responsabiliza por prejuízos decorrentes desses.
        </p>
        <p>Ao aceitar os Termos de Condição de Uso da Yes7 Tickets, o Organizador compromete-se:</p>
        <p>
          Ser o único responsável civil e criminalmente a garantir o estrito cumprimento da legislação pertinente ao
          evento, observando a aplicação das leis municipais, estaduais e federais, isentando a Yes7 Tickets de toda e
          qualquer responsabilidade.
        </p>
        <p>
          Intervirá em eventual ação judicial proposta em face da Yes7 Tickets, requerendo a sua exclusão do polo
          passivo por não possuir legitimidade, assumindo consequentemente a integral responsabilidade pelo evento.
        </p>
        <p>
          Toda a responsabilidade acerca de eventual alegação de cobrança indevida por parte do consumidor caberá ao
          organizador realizar o reembolso da taxa caso o consumidor o solicite, nos moldes da Código de Defesa do
          Consumidor.
        </p>
        <p>
          Publicará eventos que sejam verdadeiros e com suas relevantes informações fornecidas: serviços, formas de
          contato, política de cancelamento/reembolso, local do evento, data e horário, valores dos ingressos, bem como
          quaisquer outras restrições que possam existir para os participantes.
        </p>
        <p>
          Autoriza, ainda, que a Yes7 Tickets entre em contato com as partes interessadas na realização do evento, tais
          como fornecedores ou ainda com o local de realização, a fim de obter documentações ou informações que possam
          ser necessárias para validar a conformidade e veracidade de seu evento.
        </p>
        <p>
          Cada organizador deverá informar à Yes7 Tickets sobre eventual legislação estadual que implique na organização
          ou repasse de ingressos de eventos (taxa de conveniência), entre outros. Qualquer prejuízo decorrente da não
          observância de legislação estadual ou municipal específica pelo organizador, implicará na obrigatoriedade do
          ressarcimento de eventual dano a Yes7 Tickets.
        </p>
        <p>
          Sendo a Yes7 Tickets demandada nos termos expostos, e o Organizador não assumir a responsabilidade, este
          reconhece a autorização da Yes7 Tickets para efetuar o bloqueio do saldo de valores mantidos na plataforma, na
          exata medida dos valores envolvidos nas cobranças realizadas, corrigidos monetariamente. Em se tratando de
          demandas judiciais, a Yes7 Tickets pode proceder ao desconto definitivo desses valores, havendo o trânsito em
          julgado da procedência dos pedidos indenizatórios e/ou materiais.
        </p>
        <p>
          Por iguais razões, é de responsabilidade do Organiziador prestar a suficiente e adequada informação sobre os
          eventos, comprometendo-se a não praticar abusividades contra os consumidores.
        </p>
        <p>
          Não é responsabilidade da Yes7 Tickets as transações efetuadas pelo Organizador e/ou Participantes, incluindo
          as fraudes ou prejuízos decorrentes, os quais são de inteira responsabilidade do Organizador, salvo culpa
          exclusiva do consumidor ou de terceiros.
        </p>
        <p>
          É integral e exclusiva e responsabilidade do organizador frente a página do evento e a estrutura na dashboard,
          não sendo a Yes7 Tickets responsável por eventuais alterações realizadas pelo organizador, como a modificação
          na descrição, informações ou cancelamento do evento.
        </p>
        <p>
          A Yes7 Tickets não se responsabiliza pelos conteúdos disponibilizados pelos usuários, devendo o ofendido com
          eventual publicação contatar a plataforma para análise da ocorrência.
        </p>
        <p>
          Ressalta-se que a Yes7 Tickets garante a proteção intelectual de direitos autorais e de marcas, devendo o
          ofendido, ao ter os respectivos direitos violados, contatar diretamente e de imediato a Yes7 Tickets, a fim de
          cessar o ato. Para tanto, o autor da obra precisa demonstrar a veracidade da autoria e/ou titularidade da
          marca, comprovando por meio de registro no INPI — Instituto Nacional de Propriedade Industrial.
        </p>
        <p>
          Ante ação ou omissão do organizador, dolosa ou culposa, em esfera extrajudicial ou judicial, a Yes7 Tickets
          deve ser integralmente ressarcida por eventuais despesas assumidas, incluindo as custas processuais,
          honorários advocatícios contratuais e honorários advocatícios sucumbenciais.
        </p>
        <p>
          Em virtude de a Yes7 Tickets ser plataforma de intermediação para compra e venda dos ingressos, não se
          responsabiliza pelo Organizador não informar previamente as eventuais peculiaridades ou especificidades do
          evento.
        </p>
        <p>
          Os usuários se responsabilizam pela preservação e confidencialidade das respectivas credenciais de acesso,
          como login e senha, visto ser de uso pessoal e intransferível, não devendo ser compartilhado com terceiros.
        </p>
        <p>
          Declaram os usuários a plena ciência de que a utilização da plataforma, mediante o uso das credenciais de
          acesso do usuário, são de única e completa responsabilidade deste, não sendo passíveis de contestação frente a
          Yes7 Tickets.
        </p>
        <p>
          Posto isto, a Yes7 Tickets não se responsabiliza pela utilização dos serviços por terceiros com as credenciais
          do usuário, como o login e senha, caso essas sejam compartilhadas pelo usuário com terceiros ou terceiros
          tenham acesso às informações sem qualquer interferência da Yes7 Tickets.
        </p>
        <p>
          Os usuários estão cientes que a Yes7 Tickets não os contata diretamente para solicitar o login e a senha,
          razão pela qual não poderá ser responsabilizada por eventual compartilhamento com terceiros.
        </p>
        <p>
          Ao utilizar a plataforma, os usuários declaram, ante a concordância concedida a estes termos, que a Yes7
          Tickets atua como mera intermediadora, não podendo ser considerada fornecedora ou integrante da cadeia de
          fornecimento de produtos e/ou serviços, com fulcro no Código de Defesa do Consumidor.
        </p>
        <p>
          Os serviços disponibilizados pela Plataforma da Yes7 Tickets são de intermediação para criação de eventos e
          vendas dos ingressos, limitando sua responsabilidade, portanto, à gestão da plataforma, sem qualquer
          influência ou controle sobre as atividades desenvolvidas pelo Organizador.
        </p>
        <p>
          Ressalta-se que a Yes7 Tickets somente é responsável pela criação e venda dos ingressos, não podendo ser
          responsabilizada por falhas nos eventos causados pelo Organizador.
        </p>
        <p>
          Os usuários assumem a integral responsabilidade, concordando em indenizar a Yes7 Tickets por prejuízos
          decorrentes de: I. Violação das condições previstas no presente Termo de Condições de Uso e da Política de
          Privacidade e Cookies da Yes7 Tickets. II. Inexatidão ou falsidade das informações e declarações prestadas à
          plataforma. III. Descumprimento da legislação aplicável. IV. Utilização dos serviços da plataforma para fins
          ilegais, abusivos ou contrários à moral e aos bons costumes. V. Falhas na relação de consumo. VI. Atuação que,
          comprovadamente, cause danos à imagem da Yes7 Tickets. VII. Permitir que terceiros se utilizem das credenciais
          de acesso do usuário. VIII. Prática de atos que causem danos à Yes7 Tickets ou terceiros de boa-fé.
        </p>

        <h3>7. DISPOSIÇÕES GERAIS</h3>

        <p>
          Na Plataforma da Yes7 Tickets são aplicáveis, essencialmente, a Lei nº 13.709/2018 — Lei Geral de Proteção de
          Dados, Lei nº 12.965/2014 — Marco Civil da Internet e a Lei nº 8.078/1990 — Código de Defesa do Consumidor.
        </p>
        <p>
          Para a adequada utilização dos serviços disponíveis na plataforma, é necessário que o usuário não viole os
          Termos de Condições de Uso e a Política de Privacidade estabelecidos pela Yes7 Tickets. Em caso de desrespeito
          à regulamentação exposta, a Yes7 Tickets poderá suspender o usuário e a depender da gravidade da conduta,
          procederá à exclusão imediata e definitiva da conta cadastrada.
        </p>
        <p>
          Os usuários declaram a plena ciência e consentimento da utilização pela Yes7 Tickets dos dados e informações,
          a fim de executar os procedimentos inerentes aos serviços disponibilizados e/ou prevenir fraudes. Por iguais
          razões, os usuários autorizam o compartilhamento dessas informações com os organizadores ou autoridades,
          conforme disposto na Política de Privacidade e Cookies da Yes7 Tickets e na legislação vigente.
        </p>
        <p>
          O recebimento de valores pela plataforma Yes7 Tickets, referente às vendas dos ingressos, implica na aceitação
          irrevogável do Organizador em pagar as taxas e encargos previstos, bem como eventuais valores acordados no
          momento da contratação.
        </p>
        <p>
          A Yes7 Tickets poderá concretizar alterações, a qualquer momento, nos valores das taxas instituídas, prezando
          pelo restabelecimento do equilíbrio econômico-financeiro do contrato, com fulcro no artigo 478 do Código
          Civil.
        </p>
        <p>
          É reservado a Yes7 Tickets o direito de alterar o presente Termos de Condição de Uso e/ou da Política de
          Privacidade e Cookies, a qualquer tempo e a critério exclusivo e próprio.
        </p>
        <p>
          Na situação de as alterações realizadas implicarem em restrição aos direitos dos usuários, a Yes7 Tickets
          notificará previamente a mudança, possibilitando a manifestação em discordância dos usuários e a revogação do
          consentimento conferido à plataforma.
        </p>
        <p>
          A Yes7 Tickets não se responsabilizará quanto aos usuários que não receberem as informações de alterações no
          regulamento da plataforma, em razão de desatualização no cadastro pelo usuário.
        </p>
        <p>
          A cessação da utilização do serviço disponibilizado na plataforma pelo usuário, não prejudicará o direito de a
          Yes7 Tickets haver quantias devidas referentes aos serviços prestados, bem como indenizações por eventuais
          prejuízos.
        </p>
        <p>
          Os usuários se obrigam a zelar e satisfazer os Termos de Condição de Uso e Política de Privacidade e Cookies
          da Yes7 Tickets, por iguais razões, comprometem-se a não violar a legislação aplicável, especialmente o Código
          de Defesa do Consumidor. Abstendo-se de utilizar os serviços da plataforma para prática de atos ilegais,
          abusivos ou contrários à moral e aos bons costumes.
        </p>
        <p>
          Em suspeita de práticas ilegais, a Yes7 Tickets se reserva o direito de bloquear a conta do usuário ou
          proceder à exclusão imediata e sem aviso prévio, do mesmo modo que poderá compartilhar informações do usuário
          com as autoridades competentes.
        </p>
        <p>
          Sem prejuízo das vedações legais, os usuários declaram a ciência e concordância que o uso da plataforma Yes7
          Tickets não pode estar atrelado a: I. Informações ou conteúdos que violem a lei, moral e bons costumes. II.
          Práticas de atividades ilícitas. III. Utilização da Plataforma Yes7 Tickets para desrespeitar os termos da
          legislação vigente. IV. Violação aos direitos de propriedade da Yes7 Tickets ou de terceiros.
        </p>
        <p>
          A utilização indevida das funcionalidades disponibilizadas pela Eventiva, implicará na suspensão do usuário e,
          a depender da gravidade, imediata exclusão da conta, sendo retidos os saldos constantes na plataforma, a fim
          de ser direcionado aos terceiros ou a própria Yes7 Tickets quando lesados pelas práticas inapropriadas.
        </p>
        <p>
          A concordância conferida a Plataforma Yes7 Tickets, terá validade para todos os fins de fato e de direito,
          contraindo os usuários os direitos e obrigações previstos.
        </p>
        <p>
          Consentindo com o envio, os usuários cadastrados poderão receber, via e-mail, informações sobre o evento no
          qual se cadastraram, bem como futuros eventos que a Yes7 Tickets entenda ser de interesse do participante.
        </p>
        <p>
          Os termos e condições poderão ser atualizados e alterados sem aviso prévio, mas o usuário será informado
          quando houver qualquer alteração ou mudança nas regras estabelecidas. A eventual tolerância sobre as regras do
          termo será considerada mera liberalidade e não será interpretada como novação, precedente invocável, renúncia
          a direitos, alteração tácita dos termos contratuais, direito adquirido ou alteração contratual.
        </p>
        <p>
          Eventual descontentamento dos usuários ou dificuldade em usar a plataforma, deve ser informada a equipe da
          Yes7 Tickets, que se esforçará para o melhor atendimento e resolução da controvérsia.
        </p>
        <p>
          Os usuários declaram e aceitam ser os únicos responsáveis, civil e criminalmente, por garantir o estrito
          cumprimento da legislação em todos os seus atos, incluindo o cumprimento das legislações municipais e
          estaduais.
        </p>
        <p>
          Os usuários declaram que leram e concordam os termos e condições, em sua integralidade, apresentadas acima.
        </p>

        <h3>8. FORO DE ELEIÇÃO</h3>
        <p>
          As partes elegem o foro da Comarca de Campinas, Estado de São Paulo, como competente para dirimir quaisquer
          controvérsias oriundas do presente Termo, renunciando expressamente qualquer outro, por mais privilegiado que
          o seja.
        </p>

        <h3>9. CONTATOS</h3>

        <p>Havendo dúvidas sobre as disposições destes termos ou demais documentos relacionados, entre em contato:</p>
        <p>YES 7 TICKETS LTDA.</p>
        <p>Sede: Foz do Iguaçu - PR</p>
        <p>Endereço eletrônico: contato&#64;yes7tickets.net</p>

        <h3>10. CONCORDÂNCIA COM OS TERMOS DE CONDIÇÕES DE USO</h3>

        <p>
          A utilização do serviço oferecido pela plataforma está condicionada à concordância dos Termos e Condições
          estabelecidos pela Yes7 Tickets. Referido aceite é a manifestação de anuência do usuário, favoravelmente a
          regulamentação prevista neste documento. Desta feita, ante a manifestação favorável, presume-se que o usuário
          procedeu à leitura, comprometendo-se em cumprir as previsões contratuais expostas.
        </p>
        <p>
          Ao clicar em aceito e concordo com os Termos e Condições de Uso, o usuário garante a completa e irrestrita
          aceitação dos seus termos. Qualquer dúvida remanescente poderá ser verificada no FAQ ou questionada por e-mail
          que a equipe da Yes7 Tickets ficará contente em responder.
        </p>
      </div>
    </div>
  </div>
</app-layout>
